import { RcSubMenu } from '../../../hooks/menu';
import React from 'react';
import { DropdownSubMenuWrapper } from './DropdownSubMenuWrapper';
export function DropdownSubMenu(props) {
  return React.createElement(RcSubMenu, Object.assign({}, props), React.createElement(DropdownSubMenuWrapper, Object.assign({}, props)));
}